import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = { style: {"margin-bottom":"20px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭")

import { onMounted, reactive, ref, unref } from 'vue';
import { ElMessage, ElScrollbar } from 'element-plus';

/* Components */
import { GbDialog } from '@/components/GbDialog/Index';

/* APIS */
import { GetMainstaySelectApi } from '@/apis/basics/mainstay.api';
import { GetCatValidListApi, SetCatValidApi } from '@/apis/ct_categorys/category.api';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const state = reactive({
	show: false,
	loading: false,
	categoryId: '',
	categoryName: '',
	mainstayList: [],
	nodeList: [
		{ id: '19902', label: '部门批核人不能留空' },
		{ id: '19903', label: '使用人不能留空' },
		{ id: '19904', label: '会签人不能留空' },
	],
});

const validList = ref<any[]>([]);

const load = {
	getMainstayList: async () => {
		const { succeeded, errors, data } = await GetMainstaySelectApi('');

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.mainstayList = data || [];
		}
	},

	getCatValidCfgList: async (catId: string) => {
		const { succeeded, errors, data } = await GetCatValidListApi(catId);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			const cfgList = data || [];
			validList.value = state.mainstayList.map((mainstay: any) => {
				/* 配置中是否存在记录 */
				const tsm = {
					mainstay_id: mainstay.id,
					mainstay_name: mainstay.name,
				};

				state.nodeList.forEach((node: any) => {
					const configs = cfgList.filter((item: any) => {
						return item.mainstay_id == mainstay.id && item.node_id == node.id;
					});

					if (configs && configs.length == 1) {
						tsm[`node_${node.id}_tips`] = configs[0].tips;
						tsm[`node_${node.id}_required`] = configs[0].is_required;
					} else {
						tsm[`node_${node.id}_tips`] = node.label;
						tsm[`node_${node.id}_required`] = 'Y';
					}
				});

				return tsm;
			});
		}
	},
};

/* 按钮操作 */
const btnActions = {
	save: async () => {
		state.loading = true;

		var saveData: any = {
			category_id: state.categoryId,
			mainstay_list: [],
		};

		saveData.mainstay_list = unref(validList).map((item: any) => {
			const cfgs: any = {
				mainstay_id: item.mainstay_id,
				valid_list: [],
			};

			state.nodeList.forEach((node: any) => {
				cfgs.valid_list.push({
					node_id: node.id,
					tips: item[`node_${node.id}_tips`],
					is_required: item[`node_${node.id}_required`],
				});
			});

			return cfgs;
		});

		/* 保存数据 */
		const { succeeded, errors } = await SetCatValidApi(saveData);

		state.loading = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success('保存成功');
			state.show = false;
		}
	},
};

/* 外部调用的方法 */
const exposeFuncs = {
	/* 显示对话框 */
	showDialog: async (catId: string, catName: string) => {
		await load.getCatValidCfgList(catId);

		state.show = true;
		state.categoryId = catId;
		state.categoryName = catName;
	},
};

expose({ ...exposeFuncs });

onMounted(() => {
	load.getMainstayList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: "分类验证配置",
    style: {"width":"1000px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "w90",
        type: "primary",
        onClick: btnActions.save
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "w90",
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, "分类名称：" + _toDisplayString(_unref(state).categoryName), 1),
        _createVNode(_component_el_table, {
          data: validList.value,
          border: "",
          style: {"width":"100%"},
          height: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "mainstay_name",
              label: "主体名称",
              width: "180",
              "header-align": "center",
              fixed: "",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "部门审批",
              "header-align": "center",
              fixed: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "node_19902_required",
                  label: "是否必填",
                  align: "center",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_switch, {
                      modelValue: scope.row.node_19902_required,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19902_required) = $event),
                      style: {"--el-switch-on-color":"#ff4949","--el-switch-off-color":"#13ce66"},
                      "inline-prompt": "",
                      "active-text": "必填",
                      "inactive-text": "可空",
                      "active-value": "Y",
                      "inactive-value": "N"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "node_19902_tips",
                  label: "提示",
                  "header-align": "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input, {
                      modelValue: scope.row.node_19902_tips,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19902_tips) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "使用人确认",
              "header-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "node_19903_required",
                  label: "是否必填",
                  align: "center",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_switch, {
                      modelValue: scope.row.node_19903_required,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19903_required) = $event),
                      style: {"--el-switch-on-color":"#ff4949","--el-switch-off-color":"#13ce66"},
                      "inline-prompt": "",
                      "active-text": "必填",
                      "inactive-text": "可空",
                      "active-value": "Y",
                      "inactive-value": "N"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "node_19903_tips",
                  label: "提示",
                  "header-align": "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input, {
                      modelValue: scope.row.node_19903_tips,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19903_tips) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "合同会签",
              "header-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "node_19904_required",
                  label: "是否必填",
                  align: "center",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_switch, {
                      modelValue: scope.row.node_19904_required,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19904_required) = $event),
                      style: {"--el-switch-on-color":"#ff4949","--el-switch-off-color":"#13ce66"},
                      "inline-prompt": "",
                      "active-text": "必填",
                      "inactive-text": "可空",
                      "active-value": "Y",
                      "inactive-value": "N"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "node_19904_tips",
                  label: "提示",
                  "header-align": "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input, {
                      modelValue: scope.row.node_19904_tips,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.node_19904_tips) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})